import * as React from 'react';
import styled from 'styled-components';
import { EntityType, IAthlete, IGroup, ITeam } from '../../../data/types';
import { AthleteControls } from './athletes/AthleteControls';
import { GroupControls } from './groups/GroupControls';
import { TeamControls } from './teams/TeamControls';

interface IProps {
  entityType: EntityType;
  onSearch: (search: string) => void;
  search: string;
  groups: IGroup[];
  teams: ITeam[];
  athletes: IAthlete[];
  teamsLoading: boolean;
  groupsLoading: boolean;
  groupsFilterTeams?: string[];
  setGroupFilterTeams?: (f: string[]) => void;
  athleteFilterTeams?: string[];
  setAthleteFilterTeams?: (f: string[]) => void;
  athleteFilterGroups?: string[];
  setAthleteFilterGroups?: (f: string[]) => void;
  isAdmin: boolean;
}

/**
 * @description renders the correct controls for the currently selected entityType
 * @param props
 */
export const EntityMenu = (props: IProps): React.ReactElement => {
  return (
    <Container>
      {props.entityType === 'teams' && (
        <TeamControls
          onSearch={props.onSearch}
          search={props.search}
          teams={props.teams}
          isAdmin={props.isAdmin}
          loading={props.teamsLoading || props.groupsLoading}
        />
      )}
      {props.entityType === 'groups' && (
        <GroupControls
          onSearch={props.onSearch}
          search={props.search}
          teams={props.teams}
          teamsLoading={props.teamsLoading}
          filteredTeams={props.groupsFilterTeams}
          setFilteredTeams={props.setGroupFilterTeams}
          athletes={props.athletes}
          loading={props.teamsLoading || props.groupsLoading}
        />
      )}
      {props.entityType === 'athletes' && (
        <AthleteControls
          onSearch={props.onSearch}
          search={props.search}
          groups={props.groups}
          teams={props.teams}
          teamsLoading={props.teamsLoading}
          groupsLoading={props.groupsLoading}
          filteredGroups={props.athleteFilterGroups}
          filteredTeams={props.athleteFilterTeams}
          setFilteredGroups={props.setAthleteFilterGroups}
          setFilteredTeams={props.setAthleteFilterTeams}
          loading={props.teamsLoading || props.groupsLoading}
          athletes={props.athletes}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  background-color: var(--color-surface-6);
  min-height: 40px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px;
  @media (max-width: 1480px) {
    height: auto;
    min-height: 140px;
    padding: 16px;
  }
`;
